/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { config, SETTING_KEY } from '../../config/Config';
toast.configure();

const TimeoutCITC = ({ timeoutCITC, setTimeoutCITC }) => {
  const { t } = useTranslation();

  const getSetting = async () => {
    const resp = await axios.get(config.API_URL.SETTING.GET, {
      params: {
        key: SETTING_KEY.TIMEOUT_CITC,
      },
      headers: config.headers,
    });
    const { data } = resp;
    const { setting } = data;
    setTimeoutCITC({
      time: setting.time || 0,
    });
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handlerChange = (e) => {
    const newValue = {
      ...timeoutCITC,
      [e.target.name]: e.target.value,
    };
    setTimeoutCITC(newValue);
  };

  return (
    <div className="setting">
      <h3>{t('timeout_citc')}</h3>
      <div className="row flex items-center gap-x-4">
        <label>{t('duration')}: </label>
        <input type="number" value={timeoutCITC.time} name="time" onChange={handlerChange} />
        <label className="pr-2">{t('miliseconds')}</label>
      </div>
    </div>
  );
};
export default TimeoutCITC;
